import { withNamespaces } from 'react-i18next';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Spinner,
} from 'reactstrap';

const ToggleActivationModal = ({
    t,
    isOpen,
    toggle,
    toggleActivationMutation,
    action,
}) => {
    const renderFooter = () => {
        if (action === 'activate') {
            return (
                <>
                    <Button
                        color="secondary"
                        onClick={toggle}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button
                        color="success"
                        disabled={toggleActivationMutation.isLoading}
                        onClick={() => toggleActivationMutation.mutate(true, {
                            onSuccess: () => toggle(),
                        })}
                    >
                        {toggleActivationMutation.isLoading && (
                            <Spinner size="sm" color="white" className="me-2" />
                        )}
                        {t('Activate Settings')}
                    </Button>
                </>
            );
        }

        if (action === 'deactivate') {
            return (
                <>
                    <Button
                        color="secondary"
                        onClick={toggle}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button
                        color="danger"
                        disabled={toggleActivationMutation.isLoading}
                        onClick={() => toggleActivationMutation.mutate(false, {
                            onSuccess: () => toggle(),
                        })}
                    >
                        {toggleActivationMutation.isLoading && (
                            <Spinner size="sm" color="white" className="me-2" />
                        )}
                        {t('Deactivate Settings')}
                    </Button>
                </>
            );
        }

        if (action === 'activation_after_save') {
            return (
                <>
                    <Button
                        color="secondary"
                        onClick={toggle}
                        disabled={toggleActivationMutation.isLoading}
                    >
                        {t('Keep Inactive')}
                    </Button>

                    <Button
                        color="success"
                        onClick={() => {
                            toggleActivationMutation.mutate(true, {
                                onSuccess: () => {
                                    toggle();
                                },
                            });
                        }}
                        disabled={toggleActivationMutation.isLoading}
                    >
                        {toggleActivationMutation.isLoading && (
                            <Spinner size="sm" color="white" className="me-1" />
                        )}
                        {t('Activate Settings')}
                    </Button>
                </>
            );
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
        >
            <ModalHeader
                toggle={toggle}
            >
                {action === 'activate' || action === 'activation_after_save' ? (
                    t('Activate Email Settings')
                ) : t('Deactivate Email Settings')}
            </ModalHeader>

            <ModalBody>
                {action === 'activate' && (
                    t('Are you sure you want to activate these email settings? Once activated, all emails in the system will be sent using this configuration.')
                )}

                {action === 'deactivate' && (
                    t('Are you sure you want to deactivate these email settings? Once deactivated, emails will be sent using the system’s default settings.')
                )}

                {action === 'activation_after_save' && (
                    t('Your SMTP settings have been saved successfully. Do you want to activate them now so all system emails will be sent using this configuration?')
                )}
            </ModalBody>

            <ModalFooter>
                {renderFooter()}
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(ToggleActivationModal);
